/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

import { LinkBuilder } from 'shared-code/services/LinkBuilder'
import { publicConfig } from 'config'
import { PathApi, PathSite } from 'types.sg.path'

type PathType = Record<(PathSite | PathApi)['path'], string>

const pathMap: PathType = {
  home: '/',
  bestList: '/best-list/[slug]',
  newsletters: '/newsletters',
  newsletterPage: '/newsletters/[slug]',
  search: '/search',
  profile: '/profile/',
  contacts: '/contact',
  deals: '/deals',
  author: '/author/[slug]',
  tag: '/tag/[slug]',
  post: '/[slug]',
  apiExitPreview: '/api/exitPreview',
  apiProxy: '/api/proxy',
}

const appUrl = publicConfig('appUrl'),
  useTrailingSlash = publicConfig('useTrailingSlash')
if (!appUrl) {
  throw new Error(`Config error, appUrl: ${appUrl ?? 'undefined'}`)
}

export const linkBuilder = new LinkBuilder<PathSite, PathApi>(pathMap, appUrl, useTrailingSlash)
